

import { IInitialContextData } from '../../services/contextService';
import { IUnparsedContext } from '../../interfaces/IHavainnotContext';
import { IRole } from '../../interfaces/IHavainnotUser';
import { IAppParatemers } from '../../interfaces/AppParatemers';

export const requestInitalAppContext = "REQUEST_FETCH_INITIAL_HAVAINNOT20_CONTEXT";
const successFetchInitalAppContext = "SUCCESS_FETCH_INITIAL_HAVAINNOT20_CONTEXT";
const failureFetchInitalAppContext = "FAILURE_FETCH_INITIAL_HAVAINNOT20_CONTEXT";
export const updateAppContext = "UPDATE_HAVAINNOT20_CONTEXT";
export const successAppRoles = "SUCCESS_APP_ROLES";
export const setAppRoles = "SET_APP_ROLES";

// FETCH LOCATION TYPES
export interface IRequestFetchInitalAppContext {
    type: typeof requestInitalAppContext;
}

interface ISuccessFetchInitalAppContext {
    type: typeof successFetchInitalAppContext;
    payload: IInitialContextData;
}

interface IFailureFetchInitalAppContext {
    type: typeof failureFetchInitalAppContext;
    payload: { error: Error };
}


export interface IUpdateAppContext {
    type: typeof updateAppContext;
    payload: { context: IUnparsedContext }
}


export interface ISuccessAppRoles {
    type: typeof successAppRoles;
    payload: { roles: IRole[], params: IAppParatemers | null }
}

export interface ISetAppRoles {
    type: typeof setAppRoles;
    payload: { roles: IRole[] }
}

export type IContextAction
    = IRequestFetchInitalAppContext
    | ISuccessFetchInitalAppContext
    | IFailureFetchInitalAppContext
    | IUpdateAppContext
    | ISuccessAppRoles
    ;


export const createUpdateAppContextAction = (context: IUnparsedContext): IUpdateAppContext => ({
    type: updateAppContext,
    payload: { context }
});

export const createRequestFetchInitalAppContext = (): IRequestFetchInitalAppContext => ({
    type: requestInitalAppContext,
});

export const createSuccessFetchInitalAppContext = (initialContext: IInitialContextData): ISuccessFetchInitalAppContext => ({
    type: successFetchInitalAppContext,
    payload: { ...initialContext },
});

export const createFailureFetchInitalAppContext = (error: Error): IFailureFetchInitalAppContext => ({
    type: failureFetchInitalAppContext,
    payload: { error },
});


export const createSuccessAppRolesAction = (roles: IRole[], params: IAppParatemers | null): ISuccessAppRoles => ({
    type: successAppRoles,
    payload: { roles, params },
});

export const createSetAppRolesAction = (roles: IRole[]): ISetAppRoles => ({
    type: setAppRoles,
    payload: { roles },
});




